import * as io from 'io-ts';
import { fromRecord } from '../locale';
import { nullable } from '../source/io/io';
import { MessageRecordIO, MessageRecordLangIO } from '../source/io/message';

export const ServiceDescriptionIO = io.interface({
    code: io.string,
    name: MessageRecordIO,
    placeholder: nullable(MessageRecordIO),
});
export type ServiceDescription = io.TypeOf<typeof ServiceDescriptionIO>;

export const ServiceRequestIO = io.intersection(
    [
        io.interface({
            service: io.string,
            input: io.string,
            lang: MessageRecordLangIO,
        }),
        io.partial({ mapId: io.string }),
    ],
    'ServiceRequestIO',
);
export type ServiceRequest = io.TypeOf<typeof ServiceRequestIO>;

export const ServiceResultMessageIO = io.union([MessageRecordIO, io.string]);
export type ServiceResultMessage = io.TypeOf<typeof ServiceResultMessageIO>;

const TermResultIO = io.interface(
    {
        coord: io.interface({ y: io.number, x: io.number }),
        message: ServiceResultMessageIO,
    },
    'TermResultIO',
);
export type TermResult = io.TypeOf<typeof TermResultIO>;

const LayerResultIO = io.intersection(
    [
        TermResultIO,
        io.interface({
            layerId: io.string,
            metadataId: io.string,
            field: io.string,
            featureId: io.union([io.number, io.string]),
        }),
    ],
    'LayerResultIO',
);
export type LayerResult = io.TypeOf<typeof LayerResultIO>;

const TermResponseIO = io.interface(
    {
        kind: io.literal('term'),
        results: io.array(TermResultIO),
        error: nullable(io.string),
    },
    'TermResponseIO',
);

const LayerResponseIO = io.interface(
    {
        kind: io.literal('layers'),
        results: io.array(LayerResultIO),
        error: nullable(io.string),
    },
    'LayerResponseIO',
);

export const ServiceResponseIO = io.union([LayerResponseIO, TermResponseIO]);
export type ServiceResponse = io.TypeOf<typeof ServiceResponseIO>;

export const serviceMessageToString = (msg: ServiceResultMessage) =>
    typeof msg === 'string' ? msg : fromRecord(msg);
